module.exports = __webpack_public_path__ + "img/footer3.f03b66ae.png";